export const KEY_LABELS: Record<string, string> = {
  aggregationPeriod: "Aggregation period",
  aggregationStrategy: "Aggregation strategy",
  invoicePeriod: "Invoice period",
  billingMode: "Billing mode",
  invoiceWhenFeesExceedPayout: "Invoice when fees exceed the payout",
  negativePayout: "When the collection is negative",
  allowApprovalInAdmin: "Allow approval from Admin",
  ownerInvoicing: "Owner invoicing",
  paymentPlans: "Payment plans",
  weekEndsOn: "Week ends on",
  biWeeklyParity: "Bi-weekly parity",
  semiMonthlySplitDay: "Semi-monthly split day",
  currency: "Currency",
  defaultIngoingCurrency: "Default ingoing currency",
  defaultOutgoingCurrency: "Default outgoing currency",
  fees: "Fees",
  bookKeeping: "Daily close",
  "bookKeeping.enabled": "Push to ledger",
  "bookKeeping.accounts": "Daily close accounts",
  "bookKeeping.journal": "Ledger journal",
  "bookKeeping.clearingAccount": "Clearing account",
  "bookKeeping.recognizeVatOnDebt": "Recognize VAT on debt",
  "bookKeeping.vatAccounts": "VAT accounts",
  "bookKeeping.accountsByCurrency": "Per-currency accounts",
  "bookKeeping.postings": "Posting rules",
  "bookKeeping.writeOff": "Loss confirmation",
  "bookKeeping.postFromDate": "Post from date",
  "bookKeeping.accrualMoveLabel": "Verification label",
  "bookKeeping.fiscalYearEnd": "Financial year end",
  kpiAdjustments: "KPI adjustments",
  rental: "Rental",
  localReportingTimeZone: "Local reporting time zone",
  partnerInfo: "Partner info",
  paymentTermDays: "Payment terms",
  invoiceTo: "Invoice to",
  invoiceName: "Invoice name",
  billingStatus: "Billing status",
  billingStatusReason: "Billing status reason",
  invoiceReferences: "Invoice references",
  "params.processors": "Processors",
  "params.per": "Charged per",
  "params.quantity": "Quantity",
  resellerId: "Reseller",
  chainModel: "Stacking model",
  waterfallNetProcessorFee: "Waterfall processor netting",
  _configID: "Source version",

  calcMethod: "Calc method",
  articleNumber: "Article #",
  odooId: "Odoo id",
  fee: "Amount",
  "params.deviceType": "Device type",
  "params.kpiAdjust": "KPI adjust",
  "params.kpiBaseYear": "KPI base year",
  "params.layer": "Invoicing layer",
  "params.condition": "Condition",
  "params.chargeBasis": "Charge basis",
  "params.revenuePercent": "Revenue %",
  "params.revenueBase": "Revenue base",
  "invoiceAttachments": "Invoice attachments",
  "params.minPerTxn": "Min per transaction",
  "params.minPerKioskMonthly": "Min per kiosk / month",
  "params.ladderSteps": "Ladder steps",
  "params.scope": "Ladder scope",
  "params.globalDatabase": "Global database",
  "params.kioskGroup": "Kiosk sub-group",
  "params.ingoingCurrency": "Ingoing currency",
  "params.outgoingCurrency": "Outgoing currency",
  "params.attachment": "Invoice attachment",

  "rental.enabled": "Rental enabled",
  "rental.startDate": "Start date",
  "rental.endDate": "End date",
  "rental.feeOverride": "Monthly rent",

  "partnerInfo.vatNumber": "VAT / org number",
  "partnerInfo.odooRef": "Odoo partner ref",
  "partnerInfo.odooId": "Odoo partner id",
  odoo: "Odoo integration",
  "odoo.baseUrl": "Base URL",
  "odoo.journalCode": "Journal code",
  "odoo.accountCodes.payout": "Payout account code",
  "odoo.accountCodes.fee": "Fee account code",
  "odoo.company": "Odoo company",
  "odoo.apiKey": "API key",
};

export function keyLabel(k: string): string {
  if (!k) return k;
  if (KEY_LABELS[k]) return KEY_LABELS[k];
  return k.replace(/([A-Z])/g, " $1").replace(/^\w/, c => c.toUpperCase()).trim();
}
